// Travel Challenges - ES Module Version
let challengesList = [];

const Challenges = {
    // Load challenges based on current language
    load: async function(language = 'en') {
        try {
            // Determine which file to load based on language
            let filename = 'authentic-discovery.json'; // default English
            if (language === 'es' || language === 'es-ES') {
                filename = 'authentic-discovery-es.json';
            } else if (language === 'fr' || language === 'fr-FR') {
                filename = 'authentic-discovery-fr.json';
            }

            const response = await fetch(`./challenges/${filename}`);
            const data = await response.json();
            challengesList = data.challenges;
            console.log(`✅ Loaded ${challengesList.length} challenges in ${language}`);
            return challengesList;
        } catch (error) {
            console.error('Error loading challenges:', error);
            // Fallback to English if language file not found
            try {
                const response = await fetch('./challenges/authentic-discovery.json');
                const data = await response.json();
                challengesList = data.challenges;
                console.log('✅ Loaded fallback English challenges');
                return challengesList;
            } catch (fallbackError) {
                console.error('Error loading fallback challenges:', fallbackError);
                return [];
            }
        }
    },

    // Get all challenges
    getAll: function() {
        return challengesList;
    },

    // Get random challenge (excluding completed ones)
    getRandom: function(completedChallenges = []) {
        const available = challengesList.filter(c => !completedChallenges.includes(c.id));
        if (available.length === 0) return null;
        return available[Math.floor(Math.random() * available.length)];
    },

    // Get challenge by ID
    getById: function(id) {
        return challengesList.find(c => c.id === id);
    }
};

// Make available globally for backward compatibility
window.Challenges = Challenges;

export default Challenges;